import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectRegion,
  FieldSelectWasteReceptionPoint,
} from 'shared-pages';

import { useRootStore } from 'store';
import { isFotokiklosi } from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ code: likeObj }, { finDispNote: likeObj }, { '$collectionpoint.name$': likeObj }, { '$collectionpoint.companyVat$': likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
    // Δημιουργία ή αλλαγή εγγραφής εντός διαστήματος
    if (values.createdOrChangedStartDate || values.createdOrChangedEndDate) {
      const firstDate = buildWhereForDates(
        values.createdOrChangedStartDate,
        values.createdOrChangedEndDate,
        'firstDate',
      );
      const lastDate = buildWhereForDates(
        values.createdOrChangedStartDate,
        values.createdOrChangedEndDate,
        'lastDate',
      );
      where = {
        ...where,
        $and: {
          $or: [firstDate, lastDate],
        },
      };
    }
    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }
    if (values.wastereceptionpointId) {
      where = { ...where, wastereceptionpointId: values.wastereceptionpointId };
    }

    if (values.regionId) {
      where = { ...where, regionId: values.regionId };
    }
    if (values.wasteOriginTypeId) {
      where = { ...where, wasteOriginTypeId: values.wasteOriginTypeId };
    }

    if (values.wasteDestinationTypeId) {
      where = { ...where, wasteDestinationTypeId: values.wasteDestinationTypeId };
    }

    if (values.addressNomos) {
      where = { ...where, '$collectionpoint.addressNomos$': values.addressNomos };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  const { appStore, authStore } = useRootStore();
  const { t } = useTranslation();

  // Restrict WasteReception Points to Collector's Only
  const _restrictWastereceptionpoints =
    (appStore.isCollector || appStore.isCollectorDriver) && isFotokiklosi ? true : false;
  const _collectorId =
    appStore.isCollector || appStore.isCollectorDriver ? appStore.associatedId : undefined;

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    wastereceptionpointId: initialValues?.wastereceptionpointId ?? undefined,
    regionId: initialValues?.regionId ?? undefined,
    wasteOriginTypeId: initialValues?.wasteOriginTypeId ?? undefined,
    wasteDestinationTypeId: initialValues?.wasteDestinationTypeId ?? undefined,
    addressNomos: initialValues?.addressNomos ?? undefined,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    createdOrChangedStartDate: initialValues?.createdOrChangedStartDate ?? null,
    createdOrChangedEndDate: initialValues?.createdOrChangedEndDate ?? null,
    collectionPointId: initialValues?.collectionPointId ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Κωδικός Εντ., Δ.Α., Επωνυμία, ΑΦΜ )')}
          type="search"
          disable={disable}
        />
        <FieldDateRanger as={FormCol} label="Συλλογή από" name="startDate" name2="endDate" />
        <FieldDateRanger
          as={FormCol}
          label="Δημιουργία ή Αλλαγή από"
          name="createdOrChangedStartDate"
          name2="createdOrChangedEndDate"
        />
        {/* <FieldSelectNomos as={FormCol} /> */}
        {appStore.isPlatformOwner && <FieldSelectCollector as={FormCol} />}
        <FieldSelectWasteReceptionPoint
          as={FormCol}
          collectorId={_restrictWastereceptionpoints ? _collectorId : undefined}
        />
        <FieldSelectRegion as={FormCol} />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};

